<template>
    <div class="data-loading q_form event_stu_reg_form" :style="'min-height:'+getHeight()+'px;'">
        <template v-if="event && event.expired != 1 && student_ref == null">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12 px-0">
                        <span class="logo-css">
                            <img v-if="logo" :src="logo" style="width: 150px;height: 100px;border-radius: 5px;">
                            <img v-else :src="default_logo" style="width: 150px;height: 100px;border-radius: 5px;">
                        </span>
                        <div class="top_header">
                            <h2 v-if="company">{{ company.name }}</h2>
                            <h2 v-if="event">{{event.title}}</h2>
                            <div class="event_info">
                            <h6>
                                <i class="fa fa-calendar mr-2"></i>
                                {{cn(event,'event_times_data.event_date')}}
                            </h6>
                            <h6>
                                <i class="fa fa-clock-o mr-2"></i>
                                {{cn(event,'event_times_data.event_start_time')}} - {{cn(event,'event_times_data.event_end_time')}}
                            </h6>
                            <h6>
                                <i class="fa fa-map-marker mr-2"></i>
                                {{cn(event,'venue_address')}}
                            </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row">
                <div class="col-md-12">
                    <div class="form_title">
                        <h2>Event Registration Form</h2>
                        <h6>Please provide your information to sign up for the event.</h6>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form_area mb-2">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="single_box primary_box">
                                    <div class="single_title">Primary Information</div>
                                    <div class="form-row">
                                        <div class="col-md-12 form-group">
                                            <label class="form-label" for="email">Email <span class="text-danger">*</span>
                                            </label>
                                            <input type="email" v-model="student.email" @keyup="validateEmail()" name="email" id="email" class="form-control" placeholder="Email Address">
                                            <!-- <small v-if="!validate_email && student.email != null" class="text-danger">Invalid email!</small> -->
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label" for="given_name">Given Name <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" :disabled="field_disabled == true && student.given_name != null ? true : false" v-model="student.given_name" name="given_name" class="form-control" placeholder="Given Name" required="">
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label" for="family_name">Family Name <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" :disabled="field_disabled == true && student.family_name != null ? true : false" v-model="student.family_name" name="family_name" class="form-control" placeholder="Family Name" required="">
                                        </div>
                                        <div class="col-lg-6">
                                            <label class="form-label semibold" style="display: block;">
                                                Gender
                                                <!-- <span class="text-danger">*</span> -->
                                            </label>
                                            <div class="checkbox-detailed">
                                                <input :disabled="field_disabled == true && student.gender != null ? true : false" type="radio" name="gender" v-model="student.gender" id="check-det-1" value="Male">
                                                <label for="check-det-1" style="height: 30px !important;">
                                                    <span class="checkbox-detailed-tbl">
                                                    <span class="checkbox-detailed-cell">
                                                        <span class="checkbox-detailed-title">Male</span>
                                                    </span>
                                                    </span>
                                                </label>
                                            </div>
                                            <div class="checkbox-detailed">
                                                <input :disabled="field_disabled == true && student.gender != null ? true : false" type="radio" name="gender" v-model="student.gender" id="check-det-2" value="Female">
                                                <label for="check-det-2" style="height: 30px !important;">
                                                    <span class="checkbox-detailed-tbl">
                                                    <span class="checkbox-detailed-cell">
                                                        <span class="checkbox-detailed-title">Female</span>
                                                    </span>
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-6 form-group" v-if="cn(event_configs,'show_dob',false) == 1">
                                            <label class="form-label" for="nationality">
                                                Date of Birth
                                                <span class="text-danger">*</span>
                                                <span style="float: right;color: #21e409;" v-if="diff_in_years != null">{{diff_in_years}} Years</span>
                                            </label>
                                            <div class="input-group dateNicon" style="height: 30px !important;">
                                                <flat-pickr :config="config" @input="get_age(student.dob)" v-model="student.dob" class="form-control" placeholder="Date of Birth"/>
                                                <span class="input-group-addon">
                                                    <span class="fa fa-calendar" aria-hidden="true"></span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="form-group" :class="cn(event_configs,'show_dob',false) == 1 ? 'col-md-4' : 'col-md-6'">
                                            <label class="form-label" for="nationality">Nationality <span class="text-danger">*</span>
                                            </label>
                                            <select :disabled="field_disabled == true && student.nationality != null ? true : false" id="nationality" v-model="student.nationality" name="nationality" class="form-control" required="">
                                                <option disabled="" selected="" :value="null">Select Nationality</option>
                                                <option v-for="(item, i) in countries" :key="i" :value="item.id">{{ item.name }}</option>
                                            </select>
                                        </div>
                                        <div class="form-group mb-1" :class="cn(event_configs,'show_dob',false) == 1 ? 'col-md-4' : 'col-md-6'">
                                            <label class="form-label" for="country_residance">Country of Residence <span class="text-danger">*</span>
                                            </label>
                                            <select :disabled="field_disabled == true && student.residence_id != null ? true : false" id="country_residance_id" v-model="student.residence_id" name="residence_id" class="form-control" required="">
                                                <option disabled="" selected="" :value="null">Select Country</option>
                                                <option v-for="(item, i) in countries" :key="i" :value="item.id">{{ item.name }}</option>
                                            </select>
                                        </div>
                                        <div class="form-group mb-1" :class="cn(event_configs,'show_dob',false) == 1 ? 'col-md-4' : 'col-md-6'">
                                            <label class="form-label" for="city">City <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" :disabled="field_disabled == true && student.city != null ? true : false" v-model="student.city" name="city" class="form-control" placeholder="City" required="">
                                        </div>
                                    </div>
                                </div>
                                <div class="single_box mt-4 contact_box">
                                    <div class="single_title">Contact Information</div>
                                    <div class="form-row">
                                        <div class="col-md-12 form-group joined_form_group">
                                            <label class="form-label" for="c_number">
                                                Contact Number <span class="text-danger">*</span>
                                                <div class="apply_switch" style="margin-left: 45%;display: inline-flex;">
                                                    <div class="left">
                                                        Mark it as Whatsapp
                                                    </div>
                                                    <div class="right">
                                                        <toggle-button class="mb-1 ml-2" @change="mark_as_whatsapp()" v-model="mark" :labels="{checked: 'Yes', unchecked: 'No'}" color="#2E1153"/>
                                                    </div>
                                                </div>
                                            </label>
                                            <div class="row">
                                                <div class="col-md-5 col-5 pr-0">
                                                    <select @change="mark_as_whatsapp()" :disabled="field_disabled == true && student.mobile_country_id != null ? true : false" id="phn_country_id" v-model="student.mobile_country_id" name="mobile_country_id" class="form-control" required="">
                                                        <option disabled="" selected="" :value="null">Choose one ...</option>
                                                        <option v-for="(item, i) in countries" :key="i" :value="item.id">(+{{item.calling_code}}) {{ item.name }}</option>
                                                    </select>
                                                </div>
                                                <div class="col-md-7 col-7 pl-0">
                                                    <input @keyup="mark_as_whatsapp()" v-if="new_number == null" :disabled="field_disabled == true && student.phn_number != null ? true : false" type="text" name="phn_number" v-model="student.phn_number" id="c_number" class="form-control" placeholder="Contact Number" required="">
                                                    <input v-else :disabled="field_disabled == true && new_number != null ? true : false" type="text" name="phn_number" v-model="new_number" id="c_number" class="form-control" placeholder="Contact Number" required="">
                                                
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 form-group joined_form_group">
                                            <div class="row">
                                                <div class="col-md-2 col-2 pr-0">
                                                    <input type="text" name="" id="" class="form-control facebook" placeholder="" readonly>
                                                    <i class="fa fa-facebook"></i>
                                                </div>
                                                <div class="col-md-10 col-10 pl-0">
                                                    <input type="text" name="" id="" v-model="student.social_contacts.facebook" class="form-control" placeholder="Enter facebook profile link" required="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 form-group joined_form_group">
                                            <div class="row">
                                                <div class="col-md-2 col-2 pr-0">
                                                    <input type="text" name="" id="" class="form-control whatsapp" placeholder="" readonly>
                                                    <i class="fa fa-whatsapp"></i>
                                                </div>
                                                <div class="col-md-10 col-10 pl-0">
                                                    <input type="text" name="" v-model="student.social_contacts.whatsapp" id="" class="form-control" placeholder="Start with country code i.e. 441142725444" required="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 form-group joined_form_group mb-1">
                                            <div class="row">
                                                <div class="col-md-2 col-2 pr-0">
                                                    <input type="text" name="" id="" class="form-control telegram" placeholder="" readonly>
                                                    <i class="fa fa-paper-plane"></i>
                                                </div>
                                                <div class="col-md-10 col-10 pl-0">
                                                    <input type="text" name="" v-model="student.social_contacts.telegram" id="" class="form-control" placeholder="Telegram number" required="">
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-6 form-group joined_form_group mb-1">
                                            <div class="row">
                                                <div class="col-md-2 col-2 pr-0">
                                                    <input type="text" name="" id="" class="form-control viber" placeholder="" readonly>
                                                    <i class="fa fa-viber"></i>
                                                </div>
                                                <div class="col-md-10 col-10 pl-0">
                                                    <input type="text" name="" id="" v-model="student.social_contacts.viber" class="form-control" placeholder="Start with country code i.e. 441142725444" required="">
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="single_box mt-4 education_box" v-if="cn(event_configs,'education_history',false) == 1 && education_history == null">
                                    <div class="single_title">Educational Information (Education Background) </div>
                                    <div class="form-row">
                                    <div class="col-md-12 form-group">
                                        <label class="form-label" for="level">Academic Level 
                                            <!-- <span class="text-danger">*</span> -->
                                        </label>
                                        <select id="level" v-model="student.education.level_id" name="level" class="form-control" required="">
                                        <option disabled="" selected="" :value="null"> Choose one ... </option>
                                        <option v-for="(item, i) in levels" :key="i" :value="item.id">{{item.name}}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-12 form-group">
                                        <label class="form-label" for="subject">Subject/Area of Study 
                                            <!-- <span class="text-danger">*</span> -->
                                        </label>
                                        <input type="text" name="subject" v-model="student.education.subject" id="subject" class="form-control" placeholder="Subject" required="">
                                    </div>
                                    <div class="col-md-12 form-group">
                                        <label class="form-label" for="institute">Institute/University/College
                                            <!-- <span class="text-danger">*</span> -->
                                        </label>
                                        <input type="text" v-model="student.education.institute" name="institute" id="institute" class="form-control" placeholder="Institute" required="">
                                        <!-- <div v-if="universities_arr.length && student.institute != ''" v-click-outside="(()=>{universities_arr = [];})" id="instituteautocomplete-list" class="autocomplete-items uni-loading">
                                            <div v-for="(item, i) in universities_arr" :key="i" @click="(()=>{student.education.institute = item.name; universities_arr = []})">
                                                <span>{{item.name}}</span>
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="col-md-6 form-group joined_form_group mb-1">
                                        <label class="form-label" for="">Result 
                                            <!-- <span class="text-danger">*</span> -->
                                            </label>
                                        <div class="row">
                                            <div class="col-md-5 col-5 pr-0">
                                                <select id="" name="" v-model="student.education.unit" class="form-control" required="">
                                                    <option disabled="" selected="" :value="null">Choose one ...</option>
                                                    <option value="GPA">GPA</option>
                                                    <option value="%">%</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>
                                            <div class="col-md-7 col-7 pl-0">
                                                <input type="text" v-model="student.education.result" name="" id="" class="form-control" placeholder="Result" required="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 form-group mb-1">
                                        <label class="form-label" for="passing_year">Passing Year/Graduate Year
                                            <!-- <span class="text-danger">*</span> -->
                                        </label>
                                        <select id="level" name="passing_year" v-model="student.education.passing_year" class="form-control" required="">
                                            <option disabled="" selected="" :value="null"> Choose one ... </option>
                                            <option v-for="(item, y) in get_filtered_years('passing')" :key="y" :value="item">{{item}}</option>
                                        </select>
                                    </div>
                                    </div>
                                </div>
                                <div class="single_box mt-4" v-if="education_history != null">
                                    <div class="single_title">Education List</div>
                                    <div class="list_item_box">
                                        <div class="single">
                                            <span class="bold_text">{{education_history.institution}}</span></span>
                                            <div class="gen_text">
                                                {{education_history.subject}} ( {{education_history.result}} )
                                            </div>
                                            <div class="primary_badge mt-1">
                                                {{cn(education_history,'level.name','-')}}
                                            </div>
                                            <div class="round_radio_mark" @change="check_education()">
                                                <label>
                                                    <input type="checkbox" :checked="edu_check == true ? true : false" class="edu_history_radio">
                                                    <span></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="single_box">
                                    <div class="single_title">Preferred Study Destinations<i class="fa fa-info-circle ml-2" v-tooltip="'You can select multiple'"></i></div>
                                    <div class="destination_box mt-2 mb-3">
                                        <div class="destination_div mb-2" v-for="(item, i) in market_countries" :key="i" :class="item.selected == true ? 'destination_div_active' : ''">
                                            <div @click="selectCountry(item, '')" style="position:relative;width: 115px;height: 86px;margin-top: 20px;">
                                                <div class="flag_div" v-if="item && item.flag_url != null">
                                                    <img class="img-responsive flag_img" style="margin-top: 0% !important;" :src="item.flag_url">
                                                </div>
                                                <div class="country_div" v-if="item && item.name != null">
                                                    <strong>{{item.name}}</strong>
                                                </div>
                                            </div>
                                            <i class="fa fa-times" v-tooltip="'Unselect'" @click="selectCountry(item, 'unselect')" :class="item.selected == true ? 'times-css' : 'd-none'"></i>
                                        </div>
                                        <!-- <div class="destination_div mb-2" :class="destination_div_active">
                                            <div class="flag_div">
                                                <img class="img-responsive flag_img" src="http://sams-crm.test/assets/img/flags/1x1/ca.svg">
                                            </div>
                                            <div class="country_div">
                                                <span>Canada</span>
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="uni_lists">
                                        <div v-if="institute_load && event && event.show_institute == 1 && institutes.length" class="no_info_box text-danger">
                                            <i class="fa fa-info-circle"></i>
                                            <span class="ml-1" style="color: blue;">Please select your preferred university</span>
                                        </div>
                                        <ul class="uni_list_ul" v-if="institute_load && event && event.show_institute == 1 && institutes.length">
                                            <li v-for="(row, i) in institutes" :key="i">
                                                <!-- <img :src="cn(row,'country.flag_url','')" class="img-fluid" v-tooltip="cn(row,'country.name','')> -->
                                                {{ row.name }}
                                                <div class="pretty p-default pr-0 pull-right">
                                                    <input type="checkbox"  v-model="row.selected" @change="select_institute(row)" name="universities" checked />
                                                    <div class="state p-primary">
                                                        <label></label>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        
                                    </div>
                                    <template v-if="cn(event_configs,'admission_pref',false) == 1">
                                        <div class="single_title mt-4">Admission Preference/Course of Interest</div>
                                        <div class="form-row admission_pref_box">
                                            <div class="col-md-6 form-group">
                                                <label class="form-label" for="level">Course Level 
                                                    <!-- <span class="text-danger">*</span> -->
                                                </label>
                                                <select id="level" v-model="student.admission.course_level_id" name="level" class="form-control" required="">
                                                    <option disabled="" selected="" :value="null"> Choose one ... </option>
                                                    <option v-for="(item, i) in course_level" :key="i" :value="item.id">{{item.name}}</option>
                                                </select>
                                            </div>
                                            <div class="col-md-6 form-group">
                                                <label class="form-label" for="subject">Subject 
                                                    <!-- <span class="text-danger">*</span> -->
                                                </label>
                                                <input type="text" class="form-control" v-model="student.admission.subject" name="subject" placeholder="Enter Subject" />
                                            </div>
                                        <div class="col-md-6 form-group mb-1">
                                            <label class="form-label" for="start_date">Start Month 
                                                <!-- <span class="text-danger">*</span> -->
                                            </label>
                                            <select id="month" v-model="student.admission.start_month" name="start_month" class="form-control" required="">
                                                <option disabled="" selected="" :value="null"> Choose one ... </option>
                                                <option v-for="(item, i) in month" :key="i" :value="i+1">{{item.name}}</option>
                                            </select>
                                        </div>
                                        <div class="col-md-6 form-group mb-1">
                                            <label class="form-label" for="year">Year 
                                                <!-- <span class="text-danger">*</span> -->
                                            </label>
                                            <select id="year" name="year" v-model="student.admission.year" class="form-control" required="">
                                            <option disabled="" selected="" :value="null"> Choose one ... </option>
                                            <option v-for="(item, i) in add_pref_years" :key="i" :value="item">{{item}}</option>
                                            
                                            </select>
                                        </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="single_box mt-4">
                                    <template v-if="cn(event_configs,'language_test',false) == 1 && english_tests == null">
                                        <div class="single_title">English Test Score Information</div>
                                        <div class="form-row admission_pref_box child-loading">
                                            <div class="col-md-6 form-group">
                                                <label class="form-label" for="test_date">Test Date 
                                                    <!-- <span class="text-danger">*</span> -->
                                                </label>
                                                <div class="input-group dateNicon date_field">
                                                    <flat-pickr required="" v-model="student.language_test.test_date" placeholder="Test Date" class="form-control"/>
                                                    <span class="input-group-addon p-0 pr-2">
                                                        <span class="fa fa-calendar" aria-hidden="true"></span>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-6 form-group">
                                                <label class="form-label" for="expiry_date">Expiry Date 
                                                    <!-- <span class="text-danger">*</span> -->
                                                </label>
                                                <div class="input-group dateNicon date_field">
                                                    <flat-pickr :config="exp_configs" required="" v-model="student.language_test.exp_date" placeholder="Expiry Date" class="form-control"/>
                                                    <span class="input-group-addon p-0 pr-2">
                                                        <span class="fa fa-calendar" aria-hidden="true"></span>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-6 form-group">
                                                <label class="form-label" for="test_name">Test Name 
                                                    <!-- <span class="text-danger">*</span> -->
                                                </label>
                                                <select id="level" name="test_name" @change="get_child_field()" v-model="student.language_test.lang_test_id" class="form-control" required="">
                                                <option disabled="" selected="" :value="null"> Choose one ... </option>
                                                <option v-for="(item, i) in language_tests" :key="i" :value="item.id">{{item.short_name}}</option>
                                                </select>
                                            </div>
                                            <div class="col-md-6 form-group">
                                                <label class="form-label" for="overall">Overall Score 
                                                    <!-- <span class="text-danger">*</span> -->
                                                </label>
                                                <input type="text" name="overall" v-model="student.language_test.overall_score" placeholder="Enter Score" required="required" class="form-control">
                                            </div>
                                            
                                            <div class="col-md-6 form-group" v-for="(row, i) in student.language_test.child_language_tests" :key="i">
                                                <label class="form-label" for="listening">Subject: {{row.name}} 
                                                    <!-- <span class="text-danger">*</span> -->
                                                </label>
                                                <input type="number" name="listening" v-model="row.value" placeholder="Enter Score" required="required" class="form-control">
                                            </div>
                                        
                                        </div>
                                    </template>
                                    
                                    <template v-if="english_tests != null">
                                        <div class="single_title mt-4">Test Score List</div>
                                        <div class="list_item_box">
                                            <div class="single">
                                                <span class="bold_text">{{cn(english_tests,'language_test.name','-')}}</span>
                                                &bull;
                                                <span class="light_text">Test Date: {{dDate(cn(english_tests,'test_date',null))}}</span>
                                                <br>
                                                <div class="primary_badge mt-1">
                                                    {{cn(english_tests,'language_test.short_name','-')}}
                                                </div>
                                                <div class="test_score mt-2">
                                                    <div class="test_box" v-for="(row, ir) in english_tests.results" :key="ir">
                                                        <dl v-if="ir == 0">
                                                            <dt>{{row.result}}</dt>
                                                            <dd>Overall</dd>
                                                        </dl>
                                                        <dl v-if="ir > 0">
                                                            <dt>{{row.result}}</dt>
                                                            <dd>{{cn(row,'language_test.name','-')}}</dd>
                                                        </dl>
                                                    </div>
                                                </div>
                                                <div class="round_radio_mark" @change="check_test_score()">
                                                    <label>
                                                        <input type="checkbox" :checked="test_score_check == true ? true : false" class="test_score_radio">
                                                        <span></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <div class="single_title mt-4">Additional Remarks</div>
                                    <div class="form-row">
                                        <div class="col-md-12 form-group mb-1">
                                            <textarea name="" v-model="student.summary" id="" class="form-control" rows="5" placeholder="Enter remarks here ..."></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="btn_part mt-4 text-right">
                                    <button type="reset" @click="reset_form()" class="btn cancel_button">Reset</button>
                                    <button type="button" @click="create_student()" class="btn submit_button ml-2">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" v-if="cn(event_configs,'show_footer',false) != 1">
                    <a class="copyright text-black float-right" href="#">
                        &copy {{new Date().getFullYear()}} SAMS CRM
                    </a>
            
                </div>
            </div>
            </div>
            <div class="container-fluid" v-if="cn(event_configs,'show_footer',false) == 1">
                <div class="row">
                    <div class="col-md-12 px-0">
                        <div class="footer">
                            <div class="row">
                                <div class="col-md-8 col-5 col-lg-8">
                                    <div class="logo_box">
                                        <img v-if="logo" :src="logo" class="img-fluid">
                                        <img v-else :src="default_logo" class="img-fluid">
                                    <!-- <img src="http://sams-crm.test/assets/img/placeholders/company_logo.png" class="img-fluid"> -->
                                    </div>
                                </div>
                                <div class="col-md-4 col-7 col-lg-4">
                                    <div class="company_box">
                                        <div class="com_name">
                                            {{cn(company,'name','-')}}
                                        </div>
                                        <div class="com_info">
                                            {{cn(company,'address','-')}}, {{cn(company,'city','-')}}, {{cn(company_country,'name','-')}}
                                            <br>
                                            Tel: {{cn(contact_details,'phone_code','-')}} {{cn(contact_details,'phone','-')}}, Mob: {{cn(contact_details,'mob_code','-')}} {{cn(contact_details,'mobile','-')}}
                                            <br>
                                            Email: {{cn(head_offc,'email','-')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <a class="copyright text-black float-right" href="#">
                        &copy {{new Date().getFullYear()}} SAMS CRM
                    </a>
            
                </div>
            </div>
            
        </template>

        <registration-confirm-v2 v-if="event && event.expired != 1 && confirmation && student_ref != null"
            :company="company"
            :office="office"
            :logo="logo"
            :default_logo="default_logo"
            :contact_details="contact_details"
            :event="event"
            :student_ref="student_ref"
            @reset="reset_form()"
        />

        <div v-if="event && event.expired == 1" class="container div_show2" style="margin-left: 20%;">
            <div class="row mb-4">
                <h1 style="color:red;padding: 2rem 6rem;background: antiquewhite;width: 700px !important;margin-top: 10%;">Event date & time expired!</h1>
            </div>
        </div>
        
    </div>
</template>

<script>
import RegistrationConfirmV2 from './RegistrationConfirmV2.vue';
import moment from 'moment'
import { ToggleButton } from 'vue-js-toggle-button';
export default {
  name: "RegistrationFormV2",
    props:['baseUrl','eventId'],
    components:{
        RegistrationConfirmV2,
        ToggleButton
    },
    data() {
        return {
            confirmation:false,
            institute_load:false,
            validate_email:false,
            event:null,
            company:null,
            office:null,
            contact_details:null,
            countries:[],
            market_countries:[],
            logo:null,
            default_logo:null,
            destinations:[],
            institutes:[],
            student_ref:null,
            student:{
                event_id:null,
                given_name:null,
                family_name:null,
                email:null,
                dob:null,
                nationality:null,
                phn_number:null,
                mobile_country_id:null,
                residence_id:null,
                summary:null,
                destinations:null,
                gender:null,
                social_contacts:{
                    skype: null,
                    whatsapp: null,
                    instagram: null,
                    viber: null,
                    facebook: null,
                    telegram: null,
                    twitter: null,
                    goggle_hang: null,
                },
                education:{
                    institute:'',
                    passing_year:null,
                    unit:null,
                    level_id:null,
                    result:null
                },
                admission:{
                    course_level_id:null,
                    subject:null,
                    start_month:null,
                    year:null
                },
                language_test:{
                    test_date:null,
                    exp_date:null,
                    lang_test_id:null,
                    overall_score:null,
                    child_language_tests:[]
                }
            },
            configs: {
                dateFormat: "d M Y",
                minDate: "today"
            },
            exp_configs: {
                wrap: true,
                altFormat: 'j M, Y',
                altInput: true,
                dateFormat: 'Y-m-d', 
                // minDate: "today",
            },
            levels:[],
            course_level:[],
            years:[],
            month:[],
            uni_lists:[],
            universities_arr:[],
            add_pref_years:[],
            language_tests:[],
            education_history:null,
            edu_check:false,
            test_score_check:false,
            event_configs:null,
            english_tests:null,
            company_country:null,
            field_disabled:false,
            new_number:null,
            head_offc:null,
            mark:false,
            config:{
                wrap: true,
                altFormat: 'j M, Y',
                altInput: true,
                dateFormat: 'Y-m-d',
                maxDate: 'today'       
            },
            diff_in_years:null
        };
    },
    created() {
        
    },
    mounted() {
        this.init_data();
    },
    methods: {
        init_data:async function(){
            let ref = this;
            var jq = ref.jq();

            var url = ref.baseUrl+"/api/v1/agent/event-reg-init-data";

            ref.wait_me(".data-loading");

            try {

                let res = await jq.get(url,{event_id:ref.eventId});
                ref.event = res.data.event;
                ref.company = res.data.company;
                ref.office = res.data.office;
                ref.contact_details = res.data.contact_details
                ref.countries = res.data.countries
                ref.market_countries = res.data.market_countries
                ref.levels = res.data.levels
                ref.course_level = res.data.course_level
                ref.uni_lists = res.data.uni_lists
                ref.years = res.data.years
                ref.month = res.data.month
                ref.add_pref_years = res.data.add_pref_years
                ref.language_tests = res.data.language_tests
                ref.event_configs = res.data.configs
                ref.company_country = res.data.company_country
                ref.head_offc = res.data.head_offc
                

                if(ref.event != null && ref.event.org_mobile_country_id != null){
                    ref.student.mobile_country_id = ref.event.org_mobile_country_id;
                }
                
                if(ref.market_countries && ref.market_countries.length){
                    ref.market_countries = ref.market_countries.map(item => {
                        item.selected = false;
                        item.total = 0;
                        return item;
                    });
                }

                ref.logo = res.data.logo
                ref.default_logo = res.data.default
                ref.student.admission.year = null;
                ref.student.admission.start_month = null;

            } catch (err) {
                ref.alert(ref.err_msg(err), "error");
            } finally {
                ref.wait_me(".data-loading", "hide");
            }
        },
        getHeight(){
            var height = window.innerHeight;
            return height;
        },
        selectCountry(row, val){
            var ref = this;

            if(val == "unselect"){
                ref.market_countries = ref.market_countries.map(item => {
                    if(item.id == row.id){
                        item.selected = false
                        if(ref.destinations.length){
                            ref.destinations = ref.destinations.filter((des)=>{
                                if(des.des_id == item.id){
                                    ref.institutes = [];
                                }else{
                                    return des;
                                }
                            }); 
                        }
                        // ref.get_institutes(ref.event.id, null)
                        // item.selected = !item.selected

                    }
    
                    return item;
                })
            }else{
                ref.market_countries = ref.market_countries.map(item => {
                    if(item.id == row.id){
                        item.selected = true
                        ref.get_institutes(ref.event.id, item.id)
                        // item.selected = !item.selected
                    }
    
                    return item;
                })
            }

        },
        get_institutes:async function(event_id, des_id){
            let ref = this;
            var jq = ref.jq();

            var url = ref.baseUrl+"/api/v1/agent/get-institutes";

            ref.wait_me(".data-loading");

            var qstr = {
                event_id:event_id,
                country_id:des_id
            }

            try {

                let res = await jq.get(url, qstr);
                var universities = res.data.universities
                var colleges = res.data.colleges
                var schools = res.data.schools
                var groups = res.data.groups

                ref.institutes = [];

                if(universities.length){
                    universities.map(item => {
                        ref.institutes.push({
                            id:item.id,
                            name:item.name,
                            uni_type:3,
                            des_id:des_id,
                            selected:true
                        })
                    })
                }

                if(colleges.length){
                    colleges.map(item => {
                        ref.institutes.push({
                            id:item.id,
                            name:item.name,
                            uni_type:2,
                            des_id:des_id,
                            selected:true
                        })
                    })
                }

                if(schools.length){
                    schools.map(item => {
                        ref.institutes.push({
                            id:item.id,
                            name:item.name,
                            uni_type:1,
                            des_id:des_id,
                            selected:true
                        })
                    })
                }

                if(groups.length){
                    groups.map(item => {
                        ref.institutes.push({
                            id:item.id,
                            name:item.name,
                            uni_type:4,
                            des_id:des_id,
                            selected:true
                        })
                    })
                }


                ref.institutes = ref.institutes.map(item => {
                    var des_data = ref.destinations.find(i => i.des_id == item.des_id);
                    if(des_data != null){
                        var data = des_data.institutes.find(i => i.id == item.id);
                        if(data && data != null){
                            item.selected = data.selected
                        }
                    }
                    return item;
                })

                if(ref.destinations.length){
                    var exist = ref.destinations.find(item => item.des_id == des_id);
                    if(exist == null && des_id != null){
                        ref.destinations.push({
                            des_id:des_id,
                            institutes:ref.institutes
                        })
                    }
                }else{
                    
                    if(des_id != null){
                        ref.destinations.push({
                            des_id:des_id,
                            institutes:ref.institutes
                        })
                    }
                }
                ref.institute_load = true
            } catch (err) {
                ref.alert(ref.err_msg(err), "error");
            } finally {
                ref.wait_me(".data-loading", "hide");
            }
        },
        select_institute(row){
            var ref = this;
            
            if(ref.destinations.length){
                ref.destinations = ref.destinations.map(des => {
                    if(des.des_id == row.des_id){
                        des.institutes = des.institutes.map(item => {
                            if(item.id == row.id && row.selected == false){
                                item.selected = false

                            }else if(item.id == row.id && row.selected == true){
                                item.selected = true
                            }
                            return item;
                        })
                    }
                    return des
                })
            }
        },
        create_student:async function(){
            let ref = this;
            var jq = ref.jq();

            var url = ref.baseUrl+"/api/v1/agent/event-student-registration";

            ref.wait_me(".data-loading");

            ref.student.event_id = ref.eventId
            ref.student.office_id = ref.office.id
            ref.student.destinations = ref.destinations
            try {

                let res = await jq.post(url, ref.student);
                ref.student_ref = res.data.student_ref
                ref.confirmation = true;
                ref.alert(res.msg)

            } catch (err) {
                ref.alert(ref.err_msg(err), "error");
            } finally {
                ref.wait_me(".data-loading", "hide");
            }
        },
        validateEmail:async function() {
            var re = /\S+@\S+\.\S+/;
            if(re.test(this.student.email)){
                // this.validate_email = true;
                
                await this.check_exist_email();
                
            }else{
                // this.validate_email = false
            }
        },
        check_exist_email:async function(){
            let ref = this;
            var jq = ref.jq();

            var url = ref.baseUrl+"/api/v1/agent/check-lead-email";
            try {

                let res = await jq.get(url, {email: ref.student.email});
                if(res.data.lead != null){
                    let lead = res.data.lead
                    var isConfirmed = await this.swal_is_confirmed('Hi '+lead.given_name+' '+lead.family_name, "Seems you already have an account, please continue with your existing information",'Continue', 'Create New', 'warning');
        
                    if (isConfirmed == true) {
                        
                        var social_contacts = res.data.social_contacts;
                        ref.education_history = res.data.edu_history
                        ref.english_tests = res.data.english_tests
    
                        if(lead != null){
                            ref.student.given_name = lead.given_name
                            ref.student.family_name = lead.family_name
                            ref.student.nationality = lead.nationalities_id
                            ref.student.city = lead.city
                            ref.student.mobile_country_id = lead.lead_contact.mobile_country_id
                            ref.student.phn_number = lead.lead_contact.mobile
                            ref.student.gender = lead.gender

                            if(lead && ref.cn(lead,'lead_contact.mobile',null) != null){
                                ref.new_number = lead.lead_contact.mobile.substring(0,7)+"****"
                            }
                            
                        }
    
                        if (social_contacts && social_contacts.facebook ) {
                            ref.student.social_contacts.facebook = social_contacts.facebook
                        }
    
                        if (social_contacts && social_contacts.skype ) {
                            ref.student.social_contacts.skype = social_contacts.skype
                        }
                        if (social_contacts && social_contacts.whatsapp ) {
                            ref.student.social_contacts.whatsapp = social_contacts.whatsapp
                        }
                        if (social_contacts && social_contacts.viber ) {
                            ref.student.social_contacts.viber = social_contacts.viber
                        }
                        if (social_contacts && social_contacts.twitter ) {
                            ref.student.social_contacts.twitter = social_contacts.twitter
                        }
                        if (social_contacts && social_contacts.instagram ) {
                            ref.student.social_contacts.instagram = social_contacts.instagram
                        }
                        if (social_contacts && social_contacts.telegram ) {
                            ref.student.social_contacts.telegram = social_contacts.telegram
                        }
                        if (social_contacts && social_contacts.goggle_hang ) {
                            ref.student.social_contacts.goggle_hang = social_contacts.goggle_hang
                        }

                        ref.field_disabled = true;
                    }else{
                        ref.field_disabled = false;
                        window.location.reload()
                    }

                }

            } catch (err) {
                ref.alert(ref.err_msg(err), "error");
            } finally {
                // ref.wait_me(".data-loading", "hide");
            }
            
        },
        lead_english_child_test_fields:async function(){
            let ref = this;
            var jq = ref.jq();

            var url = ref.baseUrl+"/api/v1/agent/lead-english-child-test-fields";
            try {

                let res = await jq.get(url, {language_test_id: 1});
                // ref.student_ref = res.data.student_ref
                // ref.confirmation = true;
                // ref.alert(res.msg)

            } catch (err) {
                ref.alert(ref.err_msg(err), "error");
            } finally {
                // ref.wait_me(".data-loading", "hide");
            }
        },
        get_university:async function(){
            let ref = this;
            var jq = ref.jq();

            var url = ref.baseUrl+"/api/v1/agent/get-university-list";

            // ref.wait_me(".uni-loading");
            var qstr={
                search_query: ref.student.institute
            }


            try {
                let res = await jq.get(url, qstr);
                ref.universities_arr = res.data.universities
            } catch (err) {
                ref.alert(ref.err_msg(err), "error");
            } finally {
                // ref.wait_me(".uni-loading", "hide");
            }

        },
        get_filtered_years(val){
            let cur_y = new Date().getFullYear();
            let arr = [];
            for (let index = 0; index <= 33; index++) {
                arr[index] = cur_y-index;
            }
            return arr;
        },
        get_filtered_end_years(){
            let cur_y = new Date().getFullYear();

            if (this.student.start_year != null) {
                var year = (cur_y - this.student.start_year) + 3;
                let arr = [];
                for (let index = 0; index <= year; index++) {
                    arr[index] = parseInt(this.student.start_year) + parseInt(index) ;
                }
                return arr.reverse();
            }
        },
        get_child_field:async function(){
            let ref = this;
            var jq = ref.jq();

            var url = ref.baseUrl+"/api/v1/agent/get-child-language-test";

            ref.wait_me(".child-loading");
            var qstr={
                lang_test_id: ref.student.language_test.lang_test_id
            }


            try {
                let res = await jq.get(url, qstr);
                ref.student.language_test.child_language_tests = res.data.child_language_tests

                if(ref.student.language_test.child_language_tests){
                    ref.student.language_test.child_language_tests = ref.student.language_test.child_language_tests.map((item)=>{
                        item.value = null
                        return item;
                    });
                }
            } catch (err) {
                ref.alert(ref.err_msg(err), "error");
            } finally {
                ref.wait_me(".child-loading", "hide");
            }
        },
        reset_form(){
            window.location.reload();
        },
        check_education(){
            var ref = this;
            ref.edu_check = !ref.edu_check

            if(ref.edu_check == true){
                ref.student.education.institute = ref.cn(ref.education_history,'institution','')
                ref.student.education.passing_year = ref.cn(ref.education_history,'year',null)
                ref.student.education.unit = ref.cn(ref.education_history,'unit',null)
                ref.student.education.level_id = ref.cn(ref.education_history,'level.id',null)
                ref.student.education.subject = ref.cn(ref.education_history,'subject',null)
                ref.student.education.unit = ref.cn(ref.education_history,'unit',null)
                ref.student.education.result = ref.cn(ref.education_history,'result',null)
            }else{
                ref.student.education.institute = ''
                ref.student.education.passing_year = null
                ref.student.education.unit = null
                ref.student.education.level_id = null
                ref.student.education.result = null
                ref.student.education.subject = null
            }

        },
        check_test_score(){
            var ref = this;
            ref.test_score_check = !ref.test_score_check
            if(ref.test_score_check == true){
                ref.student.language_test.test_date = ref.cn(ref.english_tests,'test_date',null)
                ref.student.language_test.exp_date = ref.cn(ref.english_tests,'expiration_date',null)
                ref.student.language_test.lang_test_id = ref.cn(ref.english_tests,'language_test_id',null)

                ref.english_tests.results.forEach((item,i) => {
                    if(i > 0){
                        ref.student.language_test.child_language_tests.push({
                            id:item.child_language_test_id,
                            name:item.language_test.name,
                            value:item.result
                        })
                    }else if(i == 0){
                        ref.student.language_test.overall_score = item.result
                    }
                })

            }else{
                ref.student.language_test.test_date = null
                ref.student.language_test.exp_date = null
                ref.student.language_test.lang_test_id = null
                ref.student.language_test.overall_score = null
                ref.student.language_test.child_language_tests = []
            }
            
        },
        mark_as_whatsapp(){
            if(this.mark == true && this.student.phn_number != null){
                var obj = this.countries.find(item => item.id == this.student.mobile_country_id)
                this.student.social_contacts.whatsapp = '+'+obj.calling_code+' '+this.student.phn_number;
            }else{
                this.student.social_contacts.whatsapp = null;
            }
        },
        get_age(dob){
            var ref = this
            // console.log(dob);
            if(dob){
                ref.diff_in_years = parseInt(moment.duration(moment().diff(moment(dob))).asYears());
            }else{
                ref.diff_in_years = 0;
            }
        }
    }
};
</script>

<style>
    .event_stu_reg_form{
        background: #f2f3f5;
        min-height: 40rem;
        cursor: default !important;
    }
    .event_stu_reg_form .top_header{
        background: #282560;
        color: #fff;
        padding: 1.725rem;
    }
    .event_stu_reg_form .top_header h2{
        text-align: center;
        letter-spacing: -0.025rem;
    }
    .event_stu_reg_form .top_header h2:nth-child(1){
        font-weight: 600;
        font-size: 1.75rem;
        margin-bottom: 1.625rem;
    }
    .event_stu_reg_form .top_header h2:nth-child(2){
        color: #e86310;
        font-weight: 700;
    }
    .event_stu_reg_form .top_header .event_info{
        width: fit-content;
        margin: 0 auto;
    }
    .event_stu_reg_form .top_header .event_info h6{
        margin-bottom: 0.875rem;
        font-size: .95rem;
    }
    .event_stu_reg_form .top_header .event_info h6:last-child{
        margin-bottom: 0;
    }
    .event_stu_reg_form .form_title{
        width: fit-content;
        margin: 3rem auto 1.5rem;
        text-align: center;
    }
    .event_stu_reg_form .form_title h2{
        font-size: 1.5rem;
        font-weight: 700;
        margin-bottom: 0.875rem;
    }
    .event_stu_reg_form .form_title h6{
        margin-bottom: 0;
        color: #868e96;
        font-weight: 500;
        font-size: 1.15rem;
    }
    .event_stu_reg_form .form_area{
        background: #fff;
        padding: 1.725rem;
        border-radius: .55rem;
    }
    .event_stu_reg_form .form_area .single_box{
        background: #f5f4fd;
        padding: 0.875rem;
        border-radius: .55rem;
    }
    .event_stu_reg_form .form_area .single_box .single_title{
        font-size: 0.813rem;
        font-weight: 600;
        color: #2377B4;
        margin-bottom: 0.875rem;
    }
    .event_stu_reg_form .form_area .single_box .form-label {
        font-size: .7rem;
        font-weight: 600;
        color: #5d5d5d!important;
    }
    .event_stu_reg_form .form_area .single_box .form-control {
        font-size: .75rem;
        border-radius: 4px 0px 0px 4px !important;
    }
    .event_stu_reg_form .form_area .single_box .joined_form_group .col-md-5 .form-control{
        border-right: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .event_stu_reg_form .form_area .single_box .joined_form_group .col-md-7 .form-control{
        border-left: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    .event_stu_reg_form .form_area .single_box select.form-control:not([size]):not([multiple]) {
        height: calc(28px + 2px);
        font-size: 0.75rem;
    }
    .event_stu_reg_form .form_area .single_box .joined_form_group .col-md-5 .form-control, .event_stu_reg_form .form_area .single_box .joined_form_group .col-md-7 .form-control{
        height: calc(28px + 2px);
    }
    .facebook:disabled, .facebook[readonly], .whatsapp:disabled, .whatsapp[readonly], .telegram:disabled, .telegram[readonly], .viber:disabled, .viber[readonly]{
        background: #fff !important;
    }
    input.facebook[placeholder], .facebook[placeholder] {
        color: #0866ff !important;
    }
    .facebook::-webkit-input-placeholder {
        color: #0866ff !important;
    }
    input.whatsapp[placeholder], .whatsapp[placeholder] {
        color: #25d366 !important;
    }
    .whatsapp::-webkit-input-placeholder {
        color: #25d366 !important;
    }
    input.telegram[placeholder], .telegram[placeholder] {
        color: #27a6e7 !important;
    }
    .telegram::-webkit-input-placeholder {
        color: #27a6e7 !important;
    }
    input.viber[placeholder], .viber[placeholder] {
        color: #463976 !important;
    }
    .viber::-webkit-input-placeholder {
        color: #463976 !important;
    }
    .facebook, .whatsapp, .telegram, .viber{
      border-right: 1px solid #dbe7ef !important;
    }
    /* WebKit, Blink, Edge */
    /* .facebook::-webkit-input-placeholder {
        color: #0866ff !important;
    } */
    /* WebKit, Blink, Edge */
    /* .facebook::-webkit-input-placeholder {
        color: #0866ff !important;
    } */
    /* Mozilla Firefox 4 to 18 */
    /* .facebook:-moz-placeholder {
       color: #0866ff !important;
       opacity:  1;
    } */
    /* Mozilla Firefox 19+ */
    /* .facebook::-moz-placeholder {
       color: #0866ff !important;
       opacity:  1;
    } */
    /* Internet Explorer 10-11 */
    /* .facebook:-ms-input-placeholder {
       color: #0866ff !important;
    } */
    /* Microsoft Edge */
    /* .facebook::-ms-input-placeholder {
       color: #0866ff !important;
    } */
    /* Most modern browsers support this now. */
    /* .facebook::placeholder {
       color: #0866ff !important;
    } */
    .list_item_box .single {
        padding: 10px 50px 12px 16px;
        margin-top: 14px;
        border-radius: 0.25rem;
        border: 1px solid #e9f0f3;
        align-items: center;
        font-size: .75rem;
        background: #fff;
        position: relative;
    }
    .list_item_box .single .bold_text{
        font-weight: 600;
        color: black;
    }
    .list_item_box .single .light_text{
        color: rgb(134, 142, 150);
    }
    .list_item_box .single .gen_text{
        font-size: .8rem;
    }
    .list_item_box .single .primary_badge {
        font-size: 0.7rem;
        padding: 2px 8px;
        border-radius: 0.25rem;
        letter-spacing: .3px;
        display: inline-block;
        background: rgb(228 246 254);
        font-weight: 500;
    }
    .list_item_box .single .round_radio_mark {
        position: absolute;
        right: 16px;
        top: 16px;
    }
    .list_item_box .single .round_radio_mark label input {
        position: absolute;
        left: -9999px;
    }
    .list_item_box .single .round_radio_mark label span:before {
        display: flex;
        flex-shrink: 0;
        content: "";
        background-color: #fff;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        transition: .25s ease;
        box-shadow: inset 0 0 0 .125em #bdc3c7;
        margin: 0 auto;
    }
    .list_item_box .single .round_radio_mark label input:checked+span:before {
        box-shadow: inset 0 0 0 .25em #2e1153;
    }
    .list_item_box .single .round_radio_mark label span{
        cursor: pointer;
    }
    .list_item_box .single .test_score{
        display: flex;
        justify-content: space-between;
    }
    .list_item_box .single .test_score .test_box{
        text-align: center;
    }
    .event_stu_reg_form .form_area .single_box .single_title .fa{
        color: #868e96;
    }
    .event_stu_reg_form .form_area .single_box .destination_box{
        display: flex;
        flex-flow: wrap;
    }
    .event_stu_reg_form .form_area .single_box .destination_box .destination_div {
        width: 7.813rem;
        height: 6.875rem;
        margin: 0.625rem 1.25rem 0.625rem 0;
        background: #fff;
    }
    /* @media only screen and (max-width: 600px) {
      .event_stu_reg_form .form_area .single_box .destination_box .destination_div {
          width: 110px;
          height: 105px;
          margin: 10px 20px 10px 0;
        }
    } */
    .event_stu_reg_form .form_area .single_box .uni_list_ul{
        list-style-type: none;
        padding-left: 0;
    }
    .event_stu_reg_form .form_area .single_box .uni_lists{
        max-height: 225px;
        height: auto;
        min-height: auto;
        overflow: scroll;
        padding-right: 8px;
        overflow-x: hidden;
    }
    .event_stu_reg_form .form_area .single_box .uni_lists::-webkit-scrollbar {
        width: 7px;
    }
    .event_stu_reg_form .form_area .single_box .uni_lists::-webkit-scrollbar-track {
        background: #f5f4fd;
        border-radius: 5px;
    }
    .event_stu_reg_form .form_area .single_box .uni_lists::-webkit-scrollbar-thumb {
        background: linear-gradient(90deg, rgba(183,180,212,1) 0%, rgb(165 164 181) 0%, #fff 75%);
        border-radius: 5px;
    }
    .event_stu_reg_form .form_area .single_box .uni_list_ul li, .event_stu_reg_form .form_area .single_box .no_info_box{
        padding: 5px 10px;
        border: 1px solid #d8e2e7;
        border-radius: 0.5rem;
        letter-spacing: .2px;
        font-size: 12px;
        background: #fff;
        margin-bottom: 8px;
        font-weight: 500;
    }
    .event_stu_reg_form .form_area .single_box .uni_list_ul li .pretty{
        margin-top: 3px;
        margin-right: 0;
    }
    .event_stu_reg_form .form_area .single_box .uni_list_ul li .pretty .state label:after, .event_stu_reg_form .form_area .single_box .uni_list_ul li .pretty .state label:before{
        border-radius: .25rem;
    }
    .event_stu_reg_form .form_area .single_box .uni_list_ul .pretty input:checked~.state.p-primary label:after{
        background: #2e1153 !important;
    }
    .event_stu_reg_form .form_area .single_box .date_field .form-control{
        background: #fff;
        border-right: 0;
    }
    .event_stu_reg_form .form_area .single_box .date_field .input-group-addon{
        background: #fff;
    }
    .event_stu_reg_form .form_area .submit_button, .event_stu_reg_form .form_area .cancel_button {
        color: #fff !important;
        border-radius: .25rem;
        padding: 0rem 1.2rem;
        height: 32px;
    }
    .event_stu_reg_form .form_area .submit_button:hover {
        color: #00a8ff !important;
        border-color: #00a8ff !important;
    }
    .event_stu_reg_form .form_area .cancel_button:hover {
        color: #ffc107 !important;
    }
    .event_stu_reg_form .form_area .submit_button {
        background: #00a8ff;
        border-color: #00a8ff;
    }
    .event_stu_reg_form .footer {
        background: #fff;
        padding: 1.725rem;
        margin-top: 4rem;
    }
    .event_stu_reg_form .footer .logo_box {
        width: 10.5rem;
    }
    .event_stu_reg_form .footer .company_box .com_name {
        font-size: 1.15rem;
        font-weight: 500;
        color: #2377B4;
        margin-bottom: .55rem;
    }
    .event_stu_reg_form .footer .company_box .com_info {
        color: #868e96;
        font-weight: 500;
        font-size: 1rem;
    }
    .event_stu_reg_form .form_area .single_box.contact_box .joined_form_group .col-md-2 .form-control{
        border-right: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .event_stu_reg_form .form_area .single_box.contact_box .joined_form_group .col-md-10 .form-control{
        border-left: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    .event_stu_reg_form .form_area .single_box.contact_box select.form-control:not([size]):not([multiple]) {
        height: calc(28px + 2px);
        font-size: 0.75rem;
    }
    .event_stu_reg_form .form_area .single_box.contact_box .joined_form_group .col-md-2 .form-control, .event_stu_reg_form .form_area .single_box.contact_box .joined_form_group .col-md-10 .form-control{
        height: calc(28px + 2px);
    }
    .event_stu_reg_form .form_area .single_box.contact_box .joined_form_group .col-md-2 .fa{
        top: 8px;
        left: 25px;
        position: absolute;
        color: #868e96;
        z-index: 1;
    }
    .event_stu_reg_form .form_area .single_box.contact_box .joined_form_group .col-md-2 .fa-paper-plane, .event_stu_reg_form .form_area .single_box.contact_box .joined_form_group .col-md-2 .fa-viber{
        top: 9px;
        left: 22px;
        font-size: .85rem;
    }
    .event_stu_reg_form .form_area .single_box.contact_box .joined_form_group .col-md-2 .fa-whatsapp{
        left: 23px;
        font-size: 1.05rem;
    }
    .event_stu_reg_form .form_area .single_box .destination_box .destination_div .flag_div .flag_img{
        width: 2.188rem;
        height: 2.188rem;
    }
    .event_stu_reg_form .form_area .single_box .destination_box .destination_div .country_div{
        font-size: 0.75rem;
        padding: 0.325rem;
        color: #5d5d5d;
        font-weight: 600;
        line-height: 1;
        /* margin-left: -40px; */
        width: 115px;
    }

    .destination_div_active {
        background: #e4f6fe !important;
        border:1px solid #bdeec7;
    }

    .times-css{
        border: 1px solid #ddd;
        height: 19px;
        width: 20px;
        border-radius: 20px;
        font-size: 13px !important;
        line-height: 1.4 !important;
        background: #fff;
        position: absolute;
        right: 2px;
        top: 2px;
        transition: .3s;
        
    }

    .times-css:hover{
        border:1px solid #bdeec7;
        transition: .3s;
        color: #35d054;
    }

    .logo-css{
        position: absolute;
        top: 27%;
        left: 4%;
    }

    @media only screen and (max-width: 600px) {
      
      .event_stu_reg_form .top_header h2:nth-child(1) {
          font-size: 1.15rem;
      }
      .event_stu_reg_form .top_header h2:nth-child(2){
          font-size: 1.25rem;
      }
      .event_stu_reg_form .top_header .event_info h6 {
          font-size: .80rem;
      }
      .event_stu_reg_form .form_title h2 {
          font-size: 1.15rem;
      }
      .event_stu_reg_form .form_title h6 {
          font-size: 0.85rem;
      }
      .event_stu_reg_form .form_area {
          padding: 0.875rem;
      }
      /* .event_stu_reg_form .form_area .single_box.contact_box .joined_form_group:nth-child(4), .event_stu_reg_form .form_area .single_box.primary_box .form-group:nth-child(5), .event_stu_reg_form .form_area .single_box.education_box .form-group:nth-child(4){
          margin-bottom: 1rem !important;
      }
      .event_stu_reg_form .form_area .single_box .admission_pref_box .form-group:nth-child(3){
          margin-bottom: 1rem !important;
      } */
      .event_stu_reg_form .form_area .single_box .destination_box .destination_div {
          width: 5.5rem;
          height: 5rem;
          margin: 0.325rem 0.625rem 0.325rem 0;
      }
      .event_stu_reg_form .form_area .single_box .destination_box .destination_div .flag_div .flag_img{
          width: 1.2rem;
          height: 1.2rem;
      }
      .event_stu_reg_form .form_area .single_box .destination_box .destination_div .country_div{
          font-size: .7rem;
      }
      .event_stu_reg_form .footer .company_box .com_name{
          font-size: 0.813rem;
          font-weight: 600;
          color: #2377B4;
          margin-bottom: 0.45rem;
      }
      .event_stu_reg_form .footer .company_box .com_info{
          font-size: 0.75rem;
      }
      .event_stu_reg_form .footer .logo_box {
          width: 5.5rem;
      }
      .event_stu_reg_form .form_area .row .col-md-6:last-child .single_box{
          margin-top: 1.5rem;
      }

    }

    @media only screen and (max-width: 767px) {
      
      .event_stu_reg_form .form_area .single_box.contact_box .joined_form_group:nth-child(4), .event_stu_reg_form .form_area .single_box.primary_box .form-group:nth-child(5), .event_stu_reg_form .form_area .single_box.education_box .form-group:nth-child(4){
          margin-bottom: 1rem !important;
      }
      .event_stu_reg_form .form_area .single_box .admission_pref_box .form-group:nth-child(3){
          margin-bottom: 1rem !important;
      }
    }

    @media only screen and (min-width: 768px) and (max-width: 990px){

      .event_stu_reg_form .form_area .single_box .destination_box .destination_div {
          width: 5.5rem;
          height: 5rem;
          margin: 0.325rem 0.625rem 0.325rem 0;
      }
      .event_stu_reg_form .form_area .single_box .destination_box .destination_div .flag_div .flag_img{
          width: 1.5rem;
          height: 1.5rem;
      }
      .event_stu_reg_form .footer .company_box .com_name{
          font-size: 0.95rem;
          font-weight: 600;
          color: #2377B4;
          margin-bottom: 0.45rem;
      }
      .event_stu_reg_form .footer .company_box .com_info{
          font-size: 0.85rem;
      }
      .event_stu_reg_form .footer .logo_box {
          width: 7.5rem;
      }

    }

    @media only screen and (min-width: 600px) and (max-width: 768px){

      .event_stu_reg_form .form_area .single_box .destination_box .destination_div {
          width: 5.5rem;
          height: 5rem;
          margin: 0.325rem 0.625rem 0.325rem 0;
      }
      .event_stu_reg_form .form_area .single_box .destination_box .destination_div .flag_div .flag_img{
          width: 1.5rem;
          height: 1.5rem;
      }
      .event_stu_reg_form .footer .company_box .com_name{
          font-size: 0.95rem;
          font-weight: 600;
          color: #2377B4;
          margin-bottom: 0.45rem;
      }
      .event_stu_reg_form .footer .company_box .com_info{
          font-size: 0.85rem;
      }
      .event_stu_reg_form .footer .logo_box {
          width: 7.5rem;
      }
      .event_stu_reg_form .form_area .row .col-md-6:last-child .single_box{
          margin-top: 1.5rem;
      }

    

    }

    @media only screen and (max-width: 600px) {
        .logo-css {
            display: none !important;
        }
    }
    
    
</style>
